module.exports = __webpack_public_path__ + "img/bingo_ball-25.ffdc4eac.png";